// src/components/common/Spinner.js
import { OptimizedImage } from '../../utils/imageManager';

const Spinner = () => {
  return (
    <div role="status" className="flex justify-center items-center h-full">
      <OptimizedImage 
        imageKey="SPINNER" 
        className="h-16 w-16 animate-spin" 
        fallback={
          <div className="h-16 w-16 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        }
      />
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default Spinner;
